import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Router } from '@angular/router';
import { Observable, of, BehaviorSubject, throwError } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import Swal from 'sweetalert2';
import { AppConfigData } from './../core/config/appConfigData';
import { ConfirmationModal } from './modals/common';
import { LoaderService } from '../core/services/loader.service';
import { SweetAlertIcon } from './constants/enum';
import { SortDescriptor } from '@progress/kendo-data-query';
import { process, State, toODataString } from '@progress/kendo-data-query';
import {
  SelectableSettings,
  SelectableMode,
} from '@progress/kendo-angular-grid';
import { LocalStorageService } from '../core/services/localStorage.service';
import { catchError } from 'rxjs/operators';
import { Validations } from './constants/validations';
@Injectable({
  providedIn: 'root',
})
export class SharedService {
  configData: any;
  private currentUserSubject: BehaviorSubject<any>;
  public selectableSettings!: SelectableSettings;
  ServiceError = Validations.ServiceError;
  public checkboxOnly = true;
  public drag = false;
  public mode: SelectableMode = 'multiple';

  constructor(
    private http: HttpClient,
    private router: Router,
    private loaderService: LoaderService,
    private localStorageService: LocalStorageService
  ) {
    this.selectableSettings = {
      checkboxOnly: this.checkboxOnly,
      mode: this.mode,
      drag: this.drag,
    };
    const currentUser = this.getCurrentUserFromLocalStorage();
    this.currentUserSubject = new BehaviorSubject<any>(currentUser);
  }

  getCurrentUserFromLocalStorage(): any {
    const currentUserString = this.localStorageService.getItem('currentUser');
    return currentUserString ? JSON.parse(currentUserString) : null;
  }

  updateCurrentUserToken(
    newToken: string,
    refreshToken: string,
    tokenExpiresOn: string
  ): void {
    const currentUser = this.getCurrentUserFromLocalStorage();
    if (currentUser) {
      currentUser.token = newToken;
      currentUser.refreshToken = refreshToken;
      currentUser.tokenExpiresOn = tokenExpiresOn;
      this.localStorageService.setItem(
        'currentUser',
        JSON.stringify(currentUser)
      );
    }
  }

  showConfirmationDialog(modalInfo: ConfirmationModal): Promise<any> {
    const swalWithBootstrapButtons = Swal.mixin({
      customClass: {
        confirmButton: 'btn btn-primary',
        cancelButton: 'btn btn-outline-primary ms-2',
      },
      buttonsStyling: false,
    });

    return swalWithBootstrapButtons.fire({
      title: modalInfo.title,
      text: modalInfo.text,
      icon: modalInfo.icon,
      showCancelButton: modalInfo.showCancelButton,
      confirmButtonText: modalInfo.confirmButtonText,
      cancelButtonText: modalInfo.cancelButtonText,
    });
  }

  getTemplates(fileName: string): Observable<any> {
    return this.http
      .get(`${AppConfigData.getTemplatesUrl}`, {
        observe: 'response',
        responseType: 'blob',
      })
      .pipe(
        // Assuming the body is JSON
        catchError((error) => {
          console.error('getTemplates failed:', error);
          this.showMessageDialog(
            SweetAlertIcon.ERROR,
            this.ServiceError.Error,
            SweetAlertIcon.ERROR
          );
          return throwError(error);
        })
      );
  }
  gatewaygetTemplates(fileName: string): Observable<any> {
    return this.http
      .get(`${AppConfigData.generategatewaystemplate}`, {
        observe: 'response',
        responseType: 'blob',
      })
      .pipe(
        // Assuming the body is JSON
        catchError((error) => {
          console.error('getTemplates failed:', error);
          this.showMessageDialog(
            SweetAlertIcon.ERROR,
            this.ServiceError.Error,
            SweetAlertIcon.ERROR
          );
          return throwError(error);
        })
      );
  }

  getDevicesBulkUpdateTemplates(): Observable<any> {
    return this.http
      .get(`${AppConfigData.getExportDeviceUrl}`, {
        observe: 'response',
        responseType: 'blob',
      })
      .pipe(
        // Assuming the body is JSON
        catchError((error) => {
          console.error('getTemplates failed:', error);
          this.showMessageDialog(
            SweetAlertIcon.ERROR,
            this.ServiceError.Error,
            SweetAlertIcon.ERROR
          );
          return throwError(error);
        })
      );
  }

  showMessageDialog_old(
    title: string,
    message: string,
    icon: SweetAlertIcon
  ): void {
    Swal.fire(title, message, icon);
  }

  showMessageDialog(
    title: string,
    message: string,
    icon: SweetAlertIcon
  ): void {
    Swal.fire({
      title,
      text: message,
      icon,
      confirmButtonText: 'OK',
      confirmButtonColor: '#2387C8' // 🔵 Blue
    });
  }

  getAllConfigData(reload?: boolean): Observable<any> {
    this.loaderService.setLoading(true);
    // if (!this.configData || reload) {
    return this.http.get<any>(AppConfigData.configUrl).pipe(
      tap((data) => {
        this.configData = data;
        this.loaderService.setLoading(false);
      })
    );
    // } else {
    //   this.loaderService.setLoading(false);
    //   return of(this.configData);
    // }
  }

  // getAllConfigData(reload?: boolean): Observable<any> {
  //   this.loaderService.setLoading(true);
  //   if (!this.configData || reload) {
  //     return this.http.get<any>(AppConfigData.configUrl).pipe(
  //       tap((data) => {
  //         this.configData = data;
  //         this.loaderService.setLoading(false);
  //       })
  //     );
  //   } else {
  //     this.loaderService.setLoading(false);
  //     return of(this.configData);
  //   }
  // }
  getAllConfigDatawithGateWayProviderId(
    gatewayProviderId?: boolean
  ): Observable<any> {
    this.loaderService.setLoading(true);
    let url = `${AppConfigData.configUrl}?gatewayProviderId=${gatewayProviderId}`;
    return this.http.get<any>(url).pipe(
      tap((data) => {
        this.configData = data;
        this.loaderService.setLoading(false);
      })
    );
  }

  updateRole(role: string, instaceFlag?: boolean): void {
    const currentUserString = this.localStorageService.getItem('currentUser');
    if (currentUserString) {
      const currentUser = JSON.parse(currentUserString);
      if (currentUser.currentUserRoleDetails) {
        currentUser.currentUserRoleDetails.role = role;
        currentUser.activeInstance = instaceFlag;
        this.localStorageService.setItem(
          'currentUser',
          JSON.stringify(currentUser)
        );
        this.currentUserSubject.next(currentUser); // Update the BehaviorSubject
      }
    } else {
      console.error('currentUser not found in localStorage');
    }
  }

  getCurrentUser(): Observable<any> {
    return this.currentUserSubject.asObservable();
  }

  createOrderByQuery(sortDescriptors: SortDescriptor[]): string {
    if (!sortDescriptors || sortDescriptors.length === 0) {
      return '';
    }

    const orderByClauses = sortDescriptors.map((descriptor) => {
      // Handle cases where dir or field might be undefined
      const field = descriptor.field?.replace(/\./g, '/') ?? '';
      const dir = descriptor.dir ?? 'asc';
      return `${field} ${dir}`;
    });

    return `$orderby=${orderByClauses.join(',')}`;
  }

  createQuery(state: State): string {
    // Implement this method to create a query string from the state object
    // This should convert the state to your API's query parameters
    // Example implementation
    const queryString = `${toODataString(state)}&$count=true`;
    console.log(queryString);

    let filterQuery = '';

    const filterIndex = queryString.indexOf('$filter=');
    if (filterIndex !== -1) {
      const filterEndIndex = queryString.indexOf('&', filterIndex);
      if (filterEndIndex !== -1) {
        filterQuery = queryString.substring(filterIndex, filterEndIndex);
      } else {
        filterQuery = queryString.substring(filterIndex);
      }
    }

    console.log(filterQuery);

    return filterQuery;
  }

  bulkUpload(url: string, file: File): Observable<HttpResponse<Blob>> {
    const formData: FormData = new FormData();
    formData.append('file', file, file.name);

    return this.http
      .post(`${url}`, formData, {
        responseType: 'blob',
        observe: 'response',
      })
      .pipe(
        catchError((error) => {
          console.error('bulkUpload failed:', error);
          this.showMessageDialog(
            'bulkUpload failed',
            this.ServiceError.Error,
            SweetAlertIcon.ERROR
          );
          return throwError(error);
        })
      );
  }

  dateFormateChnage(inputDate: any) {
    const date = new Date(inputDate);

    const options: Intl.DateTimeFormatOptions = {
      day: '2-digit',
      month: 'short',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
     // second: '2-digit',
      hour12: true, // 12-hour format with AM/PM
    };
    const formattedDate = date
      .toLocaleString('en-GB', options)
      .replace(',', '')
      .replace(' ', ' ');
    return formattedDate;
  }

  dateFormateChnageWithOutTime(inputDate: any) {
    const date = new Date(inputDate);

    const options: Intl.DateTimeFormatOptions = {
      day: '2-digit',
      month: 'short',
      year: 'numeric',
     // hour: '2-digit',
     // minute: '2-digit',
      // second: '2-digit',
      hour12: true, // 12-hour format with AM/PM
    };
    const formattedDate = date
      .toLocaleString('en-GB', options)
      .replace(',', '')
      .replace(' ', ' ');
    return formattedDate;
  }

  fiterdatesPreparedEQ(isEq: any) {
    // is equal to
    console.log(isEq);
    const beforeDate = this.getBeforeDate(isEq?.value);
    const afterDate = this.getAfterDate(isEq?.value);
    // console.log(beforeDate)
    //  console.log(afterDate)
    // Adjust the local date for timezone (GMT+0530)
    const timezoneOffsetMinutes = isEq?.value.getTimezoneOffset(); // Difference in minutes from UTC
    beforeDate.setMinutes(beforeDate.getMinutes() - timezoneOffsetMinutes); // Adjust 'before' date to UTC
    afterDate.setMinutes(afterDate.getMinutes() - timezoneOffsetMinutes); // Adjust 'after' date to UTC

    // Convert the dates to UTC at midnight (so they align correctly)
    const beforeDateUTC = this.convertToUTCAtMidnight(beforeDate);
    const afterDateUTC = this.convertToUTCAtMidnightZero(afterDate);

    // Convert the UTC dates to ISO format for query
    const beforeDateISO = beforeDateUTC.toISOString();
    const afterDateISO = afterDateUTC.toISOString();

    // console.log(beforeDateISO)
    // console.log(afterDateISO)

    let dt = {
      filters: [
        {
          field: `${isEq.field}`,
          operator: 'gt',
          value: new Date(beforeDateISO),
        },
        {
          field: `${isEq.field}`,
          operator: 'lt',
          value: new Date(afterDateISO),
        },
      ],
      logic: 'and',
    };
    console.log(dt);
    return dt;
  }

  fiterdatesPreparedNEQ(isNeq: any) {
    // Is not Equal to
    console.log(isNeq);
    const beforeDate = this.getBeforeDate(isNeq?.value);
    const afterDate = this.getAfterDate(isNeq?.value);
    const timezoneOffsetMinutes = isNeq?.value.getTimezoneOffset(); // Difference in minutes from UTC
    beforeDate.setMinutes(beforeDate.getMinutes() - timezoneOffsetMinutes); // Adjust 'before' date to UTC
    afterDate.setMinutes(afterDate.getMinutes() - timezoneOffsetMinutes); // Adjust 'after' date to UTC

    // Convert the dates to UTC at midnight (so they align correctly)
    const beforeDateUTC = this.convertToUTCAtMidnightZero(beforeDate);
    const afterDateUTC = this.convertToUTCAtMidnight(afterDate);

    //convertToUTCAtMidnightZero
    // Convert the UTC dates to ISO format for query
    const beforeDateISO = beforeDateUTC.toISOString();
    const afterDateISO = afterDateUTC.toISOString();

    // afterDate.setHours(23, 59, 59, 999);
    // beforeDate.setHours(0, 0, 0, 0);
    // const formattedStartDate = `${afterDate.getUTCFullYear()}-${(afterDate.getUTCMonth() + 1).toString().padStart(2, '0')}-${afterDate.getUTCDate().toString().padStart(2, '0')}T23:59:59.999Z`;
    //const formattedSbeforeDate = `${beforeDate.getUTCFullYear()}-${(beforeDate.getUTCMonth() + 1).toString().padStart(2, '0')}-${beforeDate.getUTCDate().toString().padStart(2, '0')}T00:00:00.000Z`;

    console.log(beforeDateISO);
    console.log(afterDateISO);
    //const afterDate = new Date(isNeq.value);

    // console.log(isNeq)

    let dt = {
      filters: [
        {
          field: `${isNeq.field}`,
          operator: 'lt',
          value: new Date(beforeDateISO),
        },
        {
          field: `${isNeq.field}`,
          operator: 'gt',
          value: new Date(afterDateISO),
        },
      ],
      logic: 'or',
    };
    console.log(dt);
    return dt;
    // Construct the query string for filtering
    // return `$filter=(${isNeq?.tempfield} it ${beforeDateISO} and ${isNeq?.tempfield} gt ${afterDateISO})`;
  }

  getBeforeDate = (date: Date): Date => {
    const beforeDate = new Date(date); // Copy the date
    beforeDate.setDate(date.getDate() - 1); // Subtract one day (local time)
    return beforeDate;
  };

  // Function to add one day (local time adjusted)
  getAfterDate = (date: Date): Date => {
    const afterDate = new Date(date); // Copy the date
    afterDate.setDate(date.getDate() + 1); // Add one day (local time)
    return afterDate;
  };

  convertToUTCAtMidnight = (date: Date): Date => {
    const utcDate = new Date(date); // Copy the date
    utcDate.setUTCHours(23, 59, 59, 999); // Set to midnight UTC
    return utcDate;
  };

  convertToUTCAtMidnightZero = (date: Date): Date => {
    const utcDate = new Date(date); // Copy the date
    utcDate.setUTCHours(0, 0, 0, 0); // Set to midnight UTC
    return utcDate;
  };

  async togetFilterOperators(filterList: any) {
    let filterDetails: {
      operator: string | undefined;
      value: any;
      field: string | undefined;
    }[] = [];

    // Recursive function to handle nested filters
    const extractFilter = (filters: any[]): void => {
      for (const filter of filters) {
        // If the filter contains further nested filters, recurse into them
        if (
          filter.filters &&
          Array.isArray(filter.filters) &&
          filter.filters.length > 0
        ) {
          extractFilter(filter.filters); // recurse into nested filters
        }

        // Otherwise, check for the filter we need (operator, value, field)
        if (filter.operator && filter.value && filter.field) {
          filterDetails.push({
            operator: filter.operator,
            value: filter.value,
            field: filter.field,
          });
          /*  field: 'toDate',
              operator: 'eq',
              value: new Date('2025-01-05T18:30:00.000Z') */

          // Log the result for debugging
          console.log(
            'Filter found - tempFilter:',
            filter.operator,
            'tempDate:',
            filter.value,
            'tempfield:',
            filter.field
          );
        }
      }
    };

    // Start the extraction process from the top level filters
    if (filterList && filterList.filter && filterList.filter.filters) {
      extractFilter(filterList.filter.filters); // Call the recursive extraction
    }

    // If no valid filter structure found, return undefined
    if (filterDetails.length === 0) {
      console.error('No valid filter details found');
      return undefined;
    }
    console.log(filterDetails);

    return filterDetails;
  }

  customizeFilterQueryEQ(isEq: any) {
    let customDateFiltersQueryEq: any[] = [];
    isEq.forEach((item: any) => {
      if (item.operator === 'eq') {
        console.log('gasQueryString', item);
        let gasQueryString = this.fiterdatesPreparedEQ(item);
        customDateFiltersQueryEq.push(gasQueryString);
        //console.log("gasQueryString", gasQueryString)
        console.log('gasQueryString', customDateFiltersQueryEq);
      }
    });
    return customDateFiltersQueryEq;
  }

  customizeFilterQueryNEQ(isNeq: any) {
    let customDateFiltersQueryNEq: any[] = [];
    isNeq.forEach((item: any) => {
      if (item.operator === 'neq') {
        console.log('gasQueryString', item);
        let gasQueryString = this.fiterdatesPreparedNEQ(item);
        customDateFiltersQueryNEq.push(gasQueryString);
        //console.log("gasQueryString", gasQueryString)
        console.log('gasQueryString', customDateFiltersQueryNEq);
      }
    });
    return customDateFiltersQueryNEq;
  }
  dateFiltercreateQuery(state: State): string {
    console.log(state);
    const queryString = `${toODataString(state, {
      utcDates: true,
    })}&$count=true`;
    console.log(queryString);

    let filterQuery = '';

    const filterIndex = queryString.indexOf('$filter=');
    if (filterIndex !== -1) {
      const filterEndIndex = queryString.indexOf('&', filterIndex);
      if (filterEndIndex !== -1) {
        filterQuery = queryString.substring(filterIndex, filterEndIndex);
      } else {
        filterQuery = queryString.substring(filterIndex);
      }
    }

    console.log(filterQuery);

    return filterQuery;
  }

  async newmodifyFilterJson(
    json: any,
    customDateFiltersQueryEq: any,
    customDateFiltersQueryNEQ: any
  ) {
    console.log('Before modification:', json);
    // console.log("Checking filter:", this.customDateFiltersQueryEq);
    // Loop through the filters to apply changes
    json.filter.filters.forEach((filterGroup: any) => {
      // Check if the filter group already has the 'modified: true' flag

      filterGroup.filters.forEach((filter: any, index: number) => {
        console.log('Checking filter:', filter);
        if (filter.operator === 'eq' && filter?.modified == undefined) {
          // We will get the filter from this.customDateFiltersQueryEq
          const customToDateFilters = customDateFiltersQueryEq.find(
            (customFilter: { filters: any[] }) =>
              customFilter.filters.some((f: any) => f.field === filter.field)
          );
          console.log('Checking filter:', customToDateFilters);
          if (customToDateFilters) {
            // Apply the custom 'toDate' filters
            const customFilters = customToDateFilters.filters;
            filterGroup.filters.splice(index, 1, ...customFilters);
            // Mark it as modified
            customFilters.forEach((f: any) => {
              f.modified = true;
            });
            //toDateModified = true;
          }
        }

        // Handling 'neq' for 'toDate'
        if (filter.operator === 'neq' && filter?.modified == undefined) {
          const customToDateFiltersNEQ = customDateFiltersQueryNEQ.find(
            (customFilter: { filters: any[] }) =>
              customFilter.filters.some((f: any) => f.field === filter.field)
          );
          if (customToDateFiltersNEQ) {
            // Apply the custom 'neq' filters for 'toDate'
            const customFiltersNEQ = customToDateFiltersNEQ.filters;
            filterGroup.filters.splice(index, 1, ...customFiltersNEQ);
            filterGroup.logic = 'or';
            // Mark as modified
            customFiltersNEQ.forEach((f: any) => {
              f.modified = true;
            });
            //toDateModified = true;
          }
        }
      });
    });

    // console.log("After modification:", json);
    return json;
  }
}
